import { PrivacyPage } from '@/pages/privacy';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/privacy')({
	component: PrivacyPage,
});
